module.exports = "//public.getcloudapp.com/packs/media/images/icons-clipboard-9f2a5054164badf7dacc9199d3d580ba.svg";